import { render, staticRenderFns } from "./NuevaReferenciaDialogComponent.vue?vue&type=template&id=38d3f2e4"
import script from "./NuevaReferenciaDialogComponent.vue?vue&type=script&lang=js"
export * from "./NuevaReferenciaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports